<script>
  import _ from 'lodash';
  import {onDestroy} from 'svelte';
  import firebase from 'firebase';
  import MessageListItem from "./MessageListItem.svelte";
  import MessageForm from "./MessageForm.svelte";

  // TODO: subscribe
  export let message;

  let messages = [];

  const unsubscribe = firebase.firestore()
      .collection('messages')
      // HACK: channelId is needed for checking permission
      .where('channelId', '==', message.data().channelId)
      .where('messageId', '==', message.id)
      .onSnapshot(snapshot => {
        messages = _.orderBy(snapshot.docs, doc => doc.data().created.seconds, 'desc');
      });

  onDestroy(() => {
    unsubscribe();
  });
</script>


<column expand style="overflow-y: auto">

  <MessageListItem message={message} showProfile hideCommentCount/>
  <row class="divider align-center">
    <span>{message.data().commentCount || 0} replies</span>
    <hr class="expand">
  </row>
  <column reverse expand style="flex-shrink: 0">
      {#each messages as m}
        <MessageListItem message={m} showProfile hideCommentCount/>
      {/each}
  </column>
</column>
<MessageForm
    channelId={message.data().channelId}
    messageId={message.id}
/>


<style>

  .divider span {
    color: #888;
    font-size: .8rem;
    margin: 8px 12px;
  }

  .divider hr {
    border: none;
    height: 0;
    border-bottom: thin solid #ccc;
    margin-right: 12px;
  }
</style>